import httpBuildQuery from '../../../procedures/http-build-query';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices`;

const buildCustomQuery = (query) => ({ ...query, f: JSON.stringify({ _notPaid: 1 }) });

export default {
  index: async (query) => await axios.get(`${ baseUri }/${ httpBuildQuery(buildCustomQuery(query)) }`),
};
